import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';


const ResetPassword = () => {
    const [gettoken, setToken] = useState(false);  
    const navigate = useNavigate();
    const [isNewPasswordVisible, setNewPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    
    const schema = Yup.object().shape({
        password: Yup.string().required('please enter new password').min(5),
        confirm_password: Yup.string().required('please confirm new password').oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
        
            const jsonData = await response.json();

            if (response.ok) {
                toast.success(jsonData.message);
                navigate('/');
            }
            else {
                toast.error(jsonData.message);
            }
        }
        catch (error) {
            toast.error(error);
        }
    };

    const toggleNewPassword = () => setNewPasswordVisible(prev => !prev);
    const toggleConfirmPassword = () => setConfirmPasswordVisible(prev => !prev);

    let token = window.location.pathname;
    token = token.split("/")[2];
    let base_encode = atob(token);
    base_encode = base_encode.split("/");

    const email = base_encode[1];
    
    var tokendate = base_encode[0].replace(/[^\d-: ]/g, '');
    tokendate = new Date(tokendate);
    tokendate = tokendate.toLocaleTimeString().replace(/:/g,'');    
    var currentTime = new Date();
    currentTime = currentTime.toLocaleTimeString().replace(/:/g,'');

    const difference = currentTime - tokendate;

    const fetchToken = async () => {    
        const response = await fetch(`${process.env.REACT_APP_API_URL}/check/${email}/${token}`);
        if (response.ok) setToken(true);
        else             setToken(false);
    }

    useEffect(() => {
        fetchToken();
    },[] );

    if (difference > 5000 || difference > 500 || gettoken === false) {
        return (
            <div className="mt-3">
                <h1 >Password reset link has expired.</h1>
            </div>
        );
    }

    return (
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="container login_content">
                        {/* <div className="account-logo">
                            <img src="/assets/img/logo.png" alt="Visions" />
                        </div> */}

                        <div className="account-box">
                            <div className="account-wrapper">
                                <h3 className="account-title mb-3">Reset Password</h3>

                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <input type="hidden" {...register('email')} value={email} />
                                    <input type="hidden" {...register('token')} value={token} />
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">New Password</label>
                                        <div className="password-container">
                                            <input className="form-control" type={isNewPasswordVisible ? 'text' : 'password'} {...register('password')} />
                                            <span className={`fa-solid ${isNewPasswordVisible ? 'fa-eye' : 'fa-eye-slash'}`}
                                                onClick={toggleNewPassword}></span>
                                        </div>
                                        <div className="text-sm text-danger">
                                            {errors.password && <p>{errors.password.message}</p>}
                                        </div>
                                    </div>
                                    <div className="input-block mb-4">
                                        <label className="col-form-label">Confirm Password</label>
                                        <div className="password-container">
                                            <input className="form-control" type={isConfirmPasswordVisible ? 'text' : 'password'} {...register('confirm_password')} />
                                            <span className={`fa-solid ${isConfirmPasswordVisible ? 'fa-eye' : 'fa-eye-slash'}`}
                                                onClick={toggleConfirmPassword}></span>
                                        </div>
                                        <div className="text-sm text-danger">
                                            {errors.confirm_password && <p>{errors.confirm_password.message}</p>}
                                        </div>
                                    </div>
                                    <div className="input-block mt-3 mb-4 text-center">
                                        <button type="submit" className="btn btn-primary account-btn">Reset Password</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ResetPassword;